import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.56 20H5.82c-.62 0-1.22-.24-1.67-.67-.2-.19-.21-.5-.02-.69.19-.2.49-.21.69-.02.27.26.63.4 1 .4h10.74c.81 0 1.46-.66 1.46-1.47V4.8c0-.36-.13-.71-.38-.98-.18-.2-.16-.51.04-.69s.51-.17.69.04c.41.44.63 1.03.63 1.63v12.75C19 18.9 17.91 20 16.56 20z',
    'M14 0H3C1.9 0 1 .9 1 2v13c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 1c.55 0 1 .45 1 1v13c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h11z',
    'M4.5 4h8c.28 0 .5.22.5.5s-.22.5-.5.5h-8c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zM4.5 6h8c.28 0 .5.22.5.5s-.22.5-.5.5h-8c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zM4.5 8h8c.28 0 .5.22.5.5s-.22.5-.5.5h-8c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zM4.5 10h8c.28 0 .5.22.5.5s-.22.5-.5.5h-8c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z',
  ],
  height: 20,
  width: 20,
});
